module.exports = __webpack_public_path__ + "img/s.e6e1813a.jpg";